<app-menu>
    <div>
        <mat-form-field appearance="fill">
            <mat-label>Select Warehouse</mat-label>
            <mat-select [(value)]="selectedWarehouse" (selectionChange)="onWarehouseSelect()">
                <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.inventory_warehouse_uuid">
                    {{ warehouse.inventory_warehouse_name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" *ngIf="showInventoryPositions">
            <mat-label>Select Customer</mat-label>
            <mat-select [(value)]="selectedWarehouseCustomer" (selectionChange)="onCustomerSelect($event)">
                <mat-option *ngFor="let customer of contactOrganizations" [value]="customer"> {{ customer }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Search Filter</mat-label>
            <input matInput type="text" [(ngModel)]="filterValue" (input)="onProductFilterChange()"
                placeholder="Enter Filter Value">
        </mat-form-field>
        <button style="margin-right: 10px" mat-raised-button color="primary" (click)="toggleComponent()">
            {{ showInventoryPositions ? 'View Row Layout' : 'View Warehouse Positions' }}
        </button>
        <button style="margin-right: 10px" mat-raised-button color="primary" (click)="exportCsv()">
            Export CSV
        </button>
        <button style="margin-right: 10px" mat-raised-button color="primary" (click)="calculateProductMetrics()">
            View Product Metrics
        </button>
        <button mat-raised-button color="primary" (click)="navigateToReports()">
            Warehouse Reports
        </button>
        <!-- <div class="toolbar-actions" style="display: flex; justify-content: flex-end">
            <div class="search-container">
              <button matTooltip="Upload Inventory File" (click)="uploadInventoryFile()" style="background-color: rgb(141, 8, 8); " mat-raised-button color="primary">
                <i style="font-size: 15px;"  class="fas fa-upload"></i>&nbsp;Upload Inventory File
              </button>&nbsp;         
            </div>
          </div>           -->
        <span class="select-and-button">
            <span><b>Total Positions:</b> {{total_positions}}</span>
            <span><b>Total Positions with Package:</b> {{total_positions_with_package}}</span>
            <span><b>Total Sq Ft:</b> {{total_sqft}}</span>
            <span><b>Total Sq Ft Used:</b> {{total_sqft_used}}</span>
            <span><b>Total Sq Ft Left:</b> {{total_sqft_left}}</span>
        </span>
    </div>

    <ng-container *ngIf="showInventoryPositions">
        <app-warehouse-positions></app-warehouse-positions>
    </ng-container>

    <ng-container *ngIf="!showInventoryPositions">
        <app-pallet-racks [selectedWarehouseUUID]="uuid"></app-pallet-racks>
    </ng-container>

</app-menu>